module.exports = __webpack_public_path__ + "img/volunteer_oschad_logo.3d4359db.svg";